// Tracks operations the user is waiting on (currently the dataset export download) so the
// auto-logout idle countdown does not advance while one is running. Holds are keyed by the
// operation's AbortController, so cancel and cleanup release the same key they registered.
const activeHolds = new Set<AbortController>();
const clearedListeners = new Set<() => void>();

export const registerIdleHold = (controller: AbortController): void => {
  activeHolds.add(controller);
};

export const unregisterIdleHold = (controller: AbortController): void => {
  if (!activeHolds.delete(controller)) {
    return;
  }

  if (activeHolds.size > 0) {
    return;
  }

  clearedListeners.forEach((listener) => listener());
};

export const hasActiveIdleHold = (): boolean => activeHolds.size > 0;

// Fires when the last hold is released, so the idle countdown can restart from that moment.
export const subscribeIdleHoldsCleared = (
  listener: () => void
): (() => void) => {
  clearedListeners.add(listener);

  return () => {
    clearedListeners.delete(listener);
  };
};
